import { Input as AntInput, InputProps } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { InputLayout } from "../layouts";

interface Props extends InputProps {
  type?: string;
  label?: string;
  rules?: { required: boolean }[];
  onSearch?: (value: string) => void;
}

const TextInput = ({
  label = "",
  children,
  style,
  className,
  suffix,
  type,
  ...props
}: Props) => {
  const renderInput = () => {
    if (!!children) return children;
    if (type === "textarea")
      return <AntInput.TextArea {...(props as any)} rows={4} />;
    if (type === "otp")
      return (
        <AntInput.OTP
          formatter={(str) => str.toUpperCase()}
          {...(props as any)}
        />
      );
    if (type === "password") return <AntInput.Password {...props} />;
    if (type === "search")
      return (
        <AntInput
          allowClear
          {...props}
          prefix={<SearchOutlined />}
          suffix={suffix}
        />
      );
    return <AntInput {...props} suffix={suffix} />;
  };

  return (
    <InputLayout
      label={label}
      style={style}
      type={type}
      className={className}
    >
      {renderInput()}
    </InputLayout>
  );
};

export default TextInput;
